import { spawn, SpawnOptions } from 'child_process';
import { logError } from './logger';

const catchError = (error?: Error) => {
  const message = error ? error.message : 'Unexpected error';

  logError(message);
  process.exit();
};

export const runCommand = (command: string, options?: SpawnOptions) => {
  return new Promise((resolve, reject) => {
    const executedCommand = spawn(command, {
      stdio: 'inherit',
      shell: true,
      ...options,
    });

    executedCommand.on('error', error => {
      reject(error);
    });

    executedCommand.on('exit', code => {
      if (code === 0) {
        resolve();
      } else {
        reject();
      }
    });
  }).catch(catchError);
};
